import React from "react";
import { Table, Tbody, Td } from "./BiBleYear.style";

const TwoSevenFiveToThreeZeroFive = () => {
  return (
    <Table>
      <Tbody>
        <tr>
          <Td>275</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.63.THSV11">
              อิสยาห์ 63,64
            </a>
          </Td>
          <Td>ฮีบรู 13</Td>
          <Td>Isaiah 63,64</Td>
          <Td>Hebrew 13</Td>

          <Td>พระบิดาของเรา</Td>
        </tr>
        <tr>
          <Td>276</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.65.THSV11">
              อิสยาห์ 65,66
            </a>
          </Td>
          <Td>ยอห์น 1</Td>
          <Td>Isaiah 65,66</Td>
          <Td>John 1</Td>

          <Td>ให้พระเจ้าเสด็จเข้ามา</Td>
        </tr>
        <tr>
          <Td>277</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.1.THSV11">
              เยเรมีย์ 1,2
            </a>
          </Td>
          <Td>สดุดี 112,113</Td>
          <Td>Jeremiah 1,2</Td>
          <Td>Psalms 112,113</Td>

          <Td>หนทางแห่งการเชื่อฟัง</Td>
        </tr>
        <tr>
          <Td>278</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.3.THSV11">
              เยเรมีย์ 3,4
            </a>
          </Td>
          <Td>ยอห์น 2</Td>
          <Td>Jeremiah 3,4</Td>

          <Td>หมายสำคัญแห่งวาระนั้น</Td>
        </tr>
        <tr>
          <Td>279</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.5.THSV11">
              เยเรมีย์ 5,6
            </a>
          </Td>
          <Td>ยอห์น 3</Td>
          <Td>Jeremiah 5,6</Td>
          <Td>John 3</Td>

          <Td>คุณเชื่อเถอะ</Td>
        </tr>
        <tr>
          <Td>280</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.7.THSV11">
              เยเรมีย์ 7,8
            </a>
          </Td>
          <Td>สดุดี 114,115</Td>
          <Td>Jeremiah 7,8</Td>
          <Td>Psalms 114,115</Td>

          <Td>ผู้ที่คุณนมัสการ</Td>
        </tr>
        <tr>
          <Td>281</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.9.THSV11">
              เยเรมีย์ 9,10
            </a>
          </Td>
          <Td>ยอห์น 4</Td>
          <Td>Jeremiah 9,10</Td>
          <Td>John 4</Td>

          <Td>คุณปิดซ่อนไม่ได้</Td>
        </tr>
        <tr>
          <Td>282</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.11.THSV11">
              เยเรมีย์ 11,12
            </a>
          </Td>
          <Td>ยอห์น 5</Td>
          <Td>Jeremiah 11,12</Td>
          <Td>John 5</Td>

          <Td>ถ้าคุณทำตาม</Td>
        </tr>
        <tr>
          <Td>283</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.13.THSV11">
              เยเรมีย์ 13,14
            </a>
          </Td>
          <Td>ยอห์น 6</Td>
          <Td>Jeremiah 13,14</Td>
          <Td>John 6</Td>

          <Td>ที่่ตระเตรียมของพระเจ้า</Td>
        </tr>
        <tr>
          <Td>284</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.15.THSV11">
              เยเรมีย์ 15,16
            </a>
          </Td>
          <Td>สดุดี 116</Td>
          <Td>Jeremiah 15,16</Td>
          <Td>Psalms 116</Td>

          <Td>ไม่พินาศสิ้นไปเสียหมด</Td>
        </tr>
        <tr>
          <Td>285</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.17.THSV11">
              เยเรมีย์ 17,18
            </a>
          </Td>
          <Td>ยอห์น 7</Td>
          <Td>Jeremiah 17,18</Td>
          <Td>John 7</Td>

          <Td>ในพระหัตถ์ของพระองค์</Td>
        </tr>
        <tr>
          <Td>286</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.19.THSV11">
              เยเรมีย์ 19,20
            </a>
          </Td>
          <Td>ยอห์น 8</Td>
          <Td>Jeremiah 19,20</Td>
          <Td>John 8</Td>

          <Td>มนุษย์ผู้บอบช้ำเพราะบาป</Td>
        </tr>
        <tr>
          <Td>287</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.21.THSV11">
              เยเรมีย์ 21,22
            </a>
          </Td>
          <Td>สดุดี 117,118</Td>
          <Td>Jeremiah 21,22</Td>
          <Td>Psalms 117,118</Td>

          <Td>ความยุติธรรมและความรัก</Td>
        </tr>
        <tr>
          <Td>288</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.23.THSV11">
              เยเรมีย์ 23,24
            </a>
          </Td>
          <Td>ยอห์น 9</Td>
          <Td>Jeremiah 23,24</Td>
          <Td>John 9</Td>

          <Td>ลืมตาขึ้นมาดู</Td>
        </tr>
        <tr>
          <Td>289</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.25.THSV11">
              เยเรมีย์ 25,26
            </a>
          </Td>
          <Td>ยอห์น 10</Td>
          <Td>Jeremiah 25,26</Td>
          <Td>John 10</Td>

          <Td>ถ้อยคำที่มีฤทธิ์เดช</Td>
        </tr>
        <tr>
          <Td>290</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.27.THSV11">
              เยเรมีย์ 27,28
            </a>
          </Td>
          <Td>ยอห์น 11</Td>
          <Td>Jeremiah 27,28</Td>
          <Td>John 11</Td>

          <Td>เรื่องของความเป็นความตาย</Td>
        </tr>
        <tr>
          <Td>291</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.29.THSV11">
              เยเรมีย์ 29-31
            </a>
          </Td>
          <Td>สดุดี 119:1-24</Td>
          <Td>Jeremiah 29-31</Td>
          <Td>Psalms 119:1-24</Td>

          <Td>มองไปอนาคต</Td>
        </tr>
        <tr>
          <Td>292</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.32.THSV11">
              เยเรมีย์ 32,33
            </a>
          </Td>
          <Td>ยอห์น 12</Td>
          <Td>Jeremiah 32,33</Td>
          <Td>John 12</Td>

          <Td>เห็นความหวังอยู่รำไร</Td>
        </tr>
        <tr>
          <Td>293</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.34.THSV11">
              เยเรมีย์ 34,35
            </a>
          </Td>
          <Td>ยอห์น 13</Td>
          <Td>Jeremiah 34,35</Td>
          <Td>John 13</Td>

          <Td>จุดยืนของคุณอยู่ที่ไหน?</Td>
        </tr>
        <tr>
          <Td>294</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.36.THSV11">
              เยเรมีย์ 36,37
            </a>
          </Td>
          <Td>สดุดี 119:25-48</Td>
          <Td>Jeremiah 36,37</Td>
          <Td>Psalms 119:25-48</Td>

          <Td>กฎหมายของพระเจ้า</Td>
        </tr>
        <tr>
          <Td>295</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.38.THSV11">
              เยเรมีย์ 38,39
            </a>
          </Td>
          <Td>ยอห์น 14</Td>
          <Td>Jeremiah 38,39</Td>
          <Td>John 14</Td>

          <Td>กลับบ้านและสบายตัว</Td>
        </tr>
        <tr>
          <Td>296</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.40.THSV11">
              เยเรมีย์ 40,41
            </a>
          </Td>
          <Td>ยอห์น 15</Td>
          <Td>Jeremiah 40,41</Td>
          <Td>John 15</Td>

          <Td>เกลียดชัง-อะไรเป็นคำตอบ?</Td>
        </tr>
        <tr>
          <Td>297</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.42.THSV11">
              เยเรมีย์ 42,43
            </a>
          </Td>
          <Td>ยอห์น 16</Td>
          <Td>Jeremiah 42,43</Td>
          <Td>John 16</Td>

          <Td>คุณกำลังไปไหน?</Td>
        </tr>
        <tr>
          <Td>298</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.44.THSV11">
              เยเรมีย์ 44-46
            </a>
          </Td>
          <Td>สดุดี 119:49-72</Td>
          <Td>Jeremiah 44-46</Td>
          <Td>Psalms 119:49-72</Td>

          <Td>ตามกฏอย่างเคร่งครัด</Td>
        </tr>
        <tr>
          <Td>299</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.47.THSV11">
              เยเรมีย์ 47,48
            </a>
          </Td>
          <Td>ยอห์น 17</Td>
          <Td>Jeremiah 47,48</Td>
          <Td>John 17</Td>

          <Td>ผู้คนที่ต้องการความช่วยเหลือ</Td>
        </tr>
        <tr>
          <Td>300</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.49.THSV11">
              เยเรมีย์ 49,50
            </a>
          </Td>
          <Td>ยอห์น 18</Td>
          <Td>Jeremiah 49,50</Td>
          <Td>John 18</Td>

          <Td>ถูกพิพากษาโทษ</Td>
        </tr>
        <tr>
          <Td>301</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/JER.51.THSV11">
              เยเรมีย์ 51,52
            </a>
          </Td>
          <Td>สดุดี 119:97-120</Td>
          <Td>Jeremiah 51,52</Td>
          <Td>Psalms 119:97-120</Td>

          <Td>คำตัดสินเป็นของพระเจ้า</Td>
        </tr>
        <tr>
          <Td>302</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/LAM.1.THSV11">
              เพลงคร่ำครวญ 1,2
            </a>
          </Td>
          <Td>ยอห์น 19</Td>
          <Td>Lamentations 1,2</Td>
          <Td>John 19</Td>

          <Td>กล่าวโทษถึงตาย</Td>
        </tr>
        <tr>
          <Td>303</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/LAM.3.THSV11">
              เพลงคร่ำครวญ 3-5
            </a>
          </Td>
          <Td>ยอห์น 20</Td>
          <Td>Lamentations 3-5</Td>
          <Td>John 20</Td>

          <Td>ความตายเป็นจุดจบหรือ?</Td>
        </tr>
        <tr>
          <Td>304</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.1.THSV11">
              เอเสเคียล 1
            </a>
          </Td>
          <Td>ยอห์น 21</Td>
          <Td>Ezekiel 1</Td>
          <Td>John 21</Td>

          <Td>ผู้มาเยือนจากสวรรค์</Td>
        </tr>
        <tr>
          <Td>305</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.2.THSV11">
              เอเสเคียล 2,3
            </a>
          </Td>
          <Td>สดุดี 119:97-120</Td>
          <Td>Ezekiel 2,3</Td>
          <Td>Psalms 119:97-120</Td>

          <Td>ฉันต้องทำอะไร</Td>
        </tr>
      </Tbody>
    </Table>
  );
};

export default TwoSevenFiveToThreeZeroFive;
